import { whiteColor } from "@config"
import createPage from "@src/components/page"
import React from "react"
import * as styles from "./pageLikes.module.scss"

import d1Img from "@images/png/16.png"
import d2Img from "@images/png/17.png"
import Numbers from "@src/components/numbers"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { animated } from "@react-spring/web"
import bgImg from "@images/2022/p9/33-100.jpg"
import icon1Img from "@images/2022/p9/34.png"
import icon2Img from "@images/2022/p9/35.png"
import icon3Img from "@images/2022/p9/36.png"
import iconCloudImg from "@images/2022/p9/37.png"
import classnames from "@src/utils/classnames"

const parseData = ({
  attributes: {
    "post-reads-count": postReads,
    "likes-count": likes,
    "interactions-count": interactions,
    "new-friends-count": friends,
  },
}) => ({
  postReads,
  likes,
  friends,
  interactions,
})

const PageLikes = createPage(
  ({ data, offset }) => {
    const { postReads, likes, interactions, friends } = parseData(data)
    const anime1Styles = useEnteringTrail(4, offset, { type: "mt" })
    const anime2Styles = useEnteringTrail(3, offset, { step: 0.4, type: "mb" })
    return (
      <>
        <div>
          <div className={classnames("iconsGroup")}>
            <div>
              <animated.img
                src={icon3Img}
                className={styles.icon3}
                style={anime1Styles[0]}
              />
              <animated.img
                src={icon2Img}
                className={styles.icon2}
                style={anime1Styles[1]}
              />
              <animated.img
                src={icon1Img}
                className={styles.icon1}
                style={anime1Styles[2]}
              />
              <animated.img
                src={iconCloudImg}
                className={styles.iconCloud}
                style={anime1Styles[3]}
              />
            </div>
          </div>
        </div>

        <div>
          {postReads > 0 && (
            <animated.p className={styles.postReads} style={anime2Styles[0]}>
              2022年 {callYou(data)}一共看过
              <br />
              <b>{postReads}</b>篇内容
            </animated.p>
          )}
          {(likes > 0 || interactions > 0) && (
            <animated.p className={styles.postReads} style={anime2Styles[1]}>
              点过<b>{likes}</b>个喜欢
              <br />
              {interactions > 0 && (
                <>
                  和<b>{interactions}</b>位用户有过互动
                </>
              )}
            </animated.p>
          )}
          {friends > 0 && (
            <animated.p className={styles.postReads} style={anime2Styles[2]}>
              新交到
              <b>{friends}</b>个朋友
            </animated.p>
          )}
        </div>
      </>
    )
  },
  {
    className: "pageLayout1",
  }
)

export const pageLikesData = {
  key: "likes",
  bgImg,
  Page: PageLikes,
  shouldHide: (data) => {
    const { postReads, likes, interactions } = parseData(data)
    return postReads === 0 && likes === 0 && interactions === 0
  },
}

PageLikes.displayName = "PageLikes"
export default PageLikes
